import { createContext } from '@lit/context'

import type { CommonFormElementSize } from '@/common/types'

import type DapDSCodePuncherSlot from './code-puncher-slot.component'

export interface CodePuncherContext {
  registerSlot: (slot: DapDSCodePuncherSlot) => number
  unregisterSlot: (slot: DapDSCodePuncherSlot) => void
  getCharAt: (index: number) => string
  setCharAt: (index: number, char: string) => void
  focusSlot: (index: number) => void
  handleKeydown: (index: number, event: KeyboardEvent) => void
  handlePaste: (event: ClipboardEvent) => void
  activeIndex: number
  mask: boolean
  disabled: boolean
  readonly: boolean
  size: CommonFormElementSize
  placeholder: string
  pattern: RegExp
  status?: 'success' | 'error'
  autocomplete: string
  slotCount: number
}

export const codePuncherContext = createContext<CodePuncherContext>(
  'dap-ds-code-puncher-context',
)
